import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { cloneDeep } from 'lodash';
import { DeviceType, getPhysicalDeviceTypes } from 'src/app/vehicles/model/device-type';
import { VehicleDeviceLocation } from 'src/app/vehicles/model/vehicle-device-location';

@Component({
  selector: 'app-device-filter',
  templateUrl: './device-filter.component.html',
  styleUrls: ['./device-filter-component.scss']
})
export class DeviceFilterComponent implements OnInit {

  @Input() singleLocation: boolean = false;
  @Input() displayedLocations: VehicleDeviceLocation[];
  @Input() configurationMode: boolean = false;
  @Output() filterLayout: EventEmitter<VehicleDeviceLocation[]> = new EventEmitter<VehicleDeviceLocation[]>();

  allLayoutDevices: VehicleDeviceLocation[] = [];
  enabledDevicesMap: { type: DeviceType; isEnabled?: boolean }[] = [];
  connectedList: string[] = [];
  itemDragging = false;

  constructor() {
  }

  ngOnInit(): void {
    this.generateBeginData();
  }

  private generateBeginData(): void {
    if (this.configurationMode) {
      this.getConfigDevices();
      this.connectedList = this.displayedLocations.map((location: VehicleDeviceLocation) => location.locationName);
    }
    else if (this.enabledDevicesMap.length === 0) {
      this.allLayoutDevices = cloneDeep(this.displayedLocations);
      this.allLayoutDevices
        .map(data => data.devices)
        .forEach(devices => {
          devices.map(dev => dev.deviceType)
            .forEach(type => {
              if (!this.enabledDevicesMap.map(data => data.type).includes(type))
                this.enabledDevicesMap.push({ type, isEnabled: true });
            });
        });
    }
  }

  filterData(event: { type: DeviceType; isEnabled: boolean }): void {
    if (!this.singleLocation) {
      this.enabledDevicesMap.find(dev => dev.type === event.type).isEnabled = !event.isEnabled;

      this.allLayoutDevices.forEach(location => {
        const vehLocation = this.displayedLocations.find(loc => loc.locationId === location.locationId);
        vehLocation.devices = location.devices.filter(dev => this.enabledDevicesMap.find(data => data.type === dev.deviceType).isEnabled);
      });
      this.filterLayout.emit(this.displayedLocations);
    }
  }

  refresh(): void {
    this.allLayoutDevices = [];
    this.enabledDevicesMap = [];
    this.generateBeginData();
  }

  private getConfigDevices(): void {
    getPhysicalDeviceTypes().forEach((type: DeviceType) =>
      this.enabledDevicesMap.push({ type, isEnabled: true }));
  }

}
